// extracted by mini-css-extract-plugin
module.exports = {"section":"MarkdownWithHeadline_section__iaA63","headline":"MarkdownWithHeadline_headline__P3JhM"};